import { Component, Input } from "@angular/core";
import { ModalService } from "@core-services/modal.service";

@Component({
	selector: "bp-modal-header",
	templateUrl: "./bp-modalheader.component.html",
	styleUrls: ["./bp-modalheader.component.scss"],
	standalone: false
})
export class BpModalHeaderComponent {
	public constructor(protected modalService: ModalService) {}

	@Input()
	public step: string;

	@Input()
	public title: string;

	@Input()
	public cssStyle: string = "mod-general";

	@Input()
	public showIndicator: boolean = true;

	public close(): void {
		this.modalService.popModalStack(this);
	}
}
